import { difference } from 'lodash';
import createCachedSelector from 're-reselect';

import { MetrikaCounterEditorSelectItem } from '../../components/MetrikaCounterEditor/MetrikaCounterEditor';
import { metrikaCounterEditorInitialData } from '../../service/MetrikaCounterEditor/MetrikaCounterEditor';
import { MetrikaCounterEditorData } from '../../typings/metrikaCounterEditor';
import { State } from '../../typings/state';

export const selectMetrikaCounterEditorById = (
    state: State,
    editorId: string
): MetrikaCounterEditorData => {
    return (
        state.metrikaCounterEditor.editors[editorId] ||
        metrikaCounterEditorInitialData
    );
};

export const selectCountersMetrikaCounterEditor = createCachedSelector(
    (state: State, savedCounters: string[]) =>
        state.metrikaCounterEditor.counters,
    (state: State, savedCounters: string[]) => savedCounters,
    (
        counters?: string[],
        savedCounters?: string[]
    ): MetrikaCounterEditorSelectItem[] => {
        if (!counters) {
            return [];
        }

        if (!counters.length) {
            return [];
        }

        const deletedSelectedCounters = difference(savedCounters, counters);

        return [
            ...deletedSelectedCounters.map((counter: string) => ({
                counter,
                isDeleted: true
            })),
            ...counters.map((counter: string) => ({
                counter,
                isDeleted: false
            }))
        ];
    }
)((state: State, savedCounters: string[]) => savedCounters.toString());
